import { canonicalizeQuestFilter } from 'lib/questFilterCanonicalization'

export type GetQuestsQueryKey = ['quests', string | null]

export const serializeFilterKey = (filter: object | null | undefined) => {
    const keyedFilter = filter as Record<string, unknown>

    return filter
        ? JSON.stringify(
              Object.keys(filter)
                  .sort()
                  .reduce<Record<string, unknown>>((result, key) => {
                      result[key] = keyedFilter[key]
                      return result
                  }, {}),
          )
        : null
}

export const getQuestsQueryKey = (
    filter: object | null | undefined,
    params: object | null | undefined = {},
): GetQuestsQueryKey => {
    const request = canonicalizeQuestFilter({ ...(filter || {}), ...(params || {}) })
    return ['quests', serializeFilterKey(request)]
}
